import { Controller } from "@hotwired/stimulus"

// Page-level "check all" for features forms (category groups use check-all).
export default class extends Controller {
  static targets = ["checkbox"]

  checkAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }
}
